import { DatePipe } from '@angular/common';
import { Component, ElementRef, Input, ViewChild } from '@angular/core';

import { ResultListModel } from '../../providers/result/result';
import { TranslateService } from '@ngx-translate/core';
import { ConfigProvider } from '../../providers/config/config';

@Component({
  selector: 'trophy-custom',
  templateUrl: 'trophy-custom.html',
  styleUrls:['./trophy-custom.scss']
})
export class TrophyCustomComponent {
  results = [{
    athleteId: 11785797,
    athleteName: "Maurice Clavel",
    cid: 295,
    commentCount: 1,
    eventDate: 1439078400000,
    eventId: 7592962,
    eventName: "Ironman 70.3 Germany",
    fanCount: 1,
    gplatz: 12,
    gtime: 15410,
    hasDatum: true,
    hasPlatz: true,
    hasStrecke: true,
    hasZeit: true,
    hitCount: 0,
    id: 7592975,
    lid: -1,
    picName: "https://spooorts.de/d/med/295/7592975/",
    resultText: "Platz 12 in 04:16:50 über 1,9-90-21,098km",
    strecke1: 1900,
    strecke2: 90000,
    strecke3: 21098,
    streckeconv: "1,9-90-21,098km",
    trophyColor: "1",
    trophyMaterial: "1",
    trophyType: "Pokal Gold"
  },
  {
    athleteId: 11785797,
    athleteName: "Test test",
    cid: 295,
    commentCount: 1,
    eventDate: 1439078400000,
    eventId: 7592962,
    eventName: "Ironman 70.3 Germany",
    fanCount: 1,
    gplatz: 12,
    gtime: 15410,
    hasDatum: true,
    hasPlatz: true,
    hasStrecke: true,
    hasZeit: true,
    hitCount: 0,
    id: 7592975,
    lid: -1,
    picName: "https://spooorts.de/d/med/295/7592975/",
    resultText: "Platz 12 in 04:16:50 über 1,9-90-21,098km",
    strecke1: 1900,
    strecke2: 90000,
    strecke3: 21098,
    streckeconv: "1,9-90-21,098km",
    trophyColor: "1",
    trophyMaterial: "1",
    trophyType: "Pokal Gold"
  }];

  @Input('offset')
  offset: string;

  @ViewChild('container1')
  container1: ElementRef;

  @ViewChild('container2')
  container2: ElementRef;

  trophy1: Trophy;
  trophy2: Trophy;

  active: Trophy3DModel = null;

  constructor(private datePipe: DatePipe, private translate: TranslateService, private config: ConfigProvider) {
    // @ts-ignore
    this.trophy1 = STROPHY;

    // @ts-ignore
    this.trophy2 = STROPHY;
    console.log('constructor ');
  }

  ngAfterViewInit() {
    for (let i = 0; i < this.results.length; i++) {
      this.parseModel(this.results[i]).then(m => {
        this.checkEqueals(m).then(hasCahnged => {
          if (hasCahnged) {
            this.active = m;
            if (i <= 0) {
              this.trophy1.start(m, this.container1.nativeElement);
            } else {
              this.trophy2.start(m, this.container2.nativeElement);
            }
          }
        });
      });
    }
  }

  ionViewWillLeave() {
    this.trophy1.stop();
    this.trophy2.stop();
    this.active = null;
  }

  async checkEqueals(model: Trophy3DModel): Promise<boolean> {
    let r = this.active;
    let l = r !== null;
    if (l) {
      let or: boolean = false;
      Object.keys(r).forEach(key => {
        or = or || r[key] !== model[key];
      });
      l = l && or;
    } else {
      l = true;
    }
    return l;
  }

  async parseModel(model: ResultListModel): Promise<Trophy3DModel> {
    console.log('parseModel');
    console.log('model', model)
    let off = parseInt(this.offset);
    let headers = document.querySelectorAll('ion-navbar');
    console.log('headers: ', headers);

    //@ts-ignore
    let headerOff = parseInt(headers[headers.length - 1].offsetHeight);
    let NOff: number = 3;

    if (!isNaN(off)) {
      //@ts-ignore
      NOff += off + headerOff;
    } else {
      NOff += headerOff;
    }
    let conf = await this.config.config;
    if (conf.platform.browser || !conf.ads || conf.ads.type !== 'google') {
      NOff += 50;
    }

    return !model
      ? {
        offset: NOff + '',
        athleteName: this.translate.instant('TROPHY_YOU_HAVE_NO_RESULTS'),
        eventName: ''
      }
      : {
        athleteName: model.athleteName,
        eventName: model.eventName,
        distance: model.streckeconv,
        time: this.timeFormat(model.gtime),
        formatedDate: this.datePipe.transform(model.eventDate, 'dd.MM.yyyy'),
        platz: model.gplatz,
        hasStrecke: model.hasStrecke,
        hasZeit: model.hasZeit,
        hasDatum: model.hasDatum,
        hasPlatz: model.hasPlatz,
        trophyColor: model.trophyColor,
        trophyMaterial: model.trophyMaterial,
        trophyType: model.trophyType,
        offset: NOff + ''
      };
  }

  timeFormat(time: number): string {
    let hour = Math.floor(time / 3600);
    time -= hour * 3600;
    let min = Math.floor(time / 60);
    time -= min * 60;

    return this.zeroHelp(hour) + ':' + this.zeroHelp(min) + ':' + this.zeroHelp(time);
  }

  zeroHelp(number): string {
    return number < 10 ? '0' + number : number;
  }
}

interface Trophy3DModel {
  athleteName?: string;
  eventName?: string;
  distance?: string;
  time?: string;
  formatedDate?: string;
  platz?: number;
  hasStrecke?: boolean;
  hasZeit?: boolean;
  hasDatum?: boolean;
  hasPlatz?: boolean;
  trophyColor?: string;
  trophyMaterial?: string;
  trophyType?: string;
  offset?: string;
}

interface Trophy {
  start(model: Trophy3DModel, element: HTMLElement);
  stop();
  swap(model: Trophy3DModel);
}
